import {ChangeDetectionStrategy, Component, inject} from '@angular/core';
import {Store} from '@ngrx/store';
import {ExtendedFormGroup} from '@aviary/forms/extensions/extended-form-group/extended-form-group';
import {DateFormFieldComponent} from '@aviary/forms/fields/date-form-field/date-form-field.component';
import {InputFormFieldComponent} from '@aviary/forms/fields/input-form-field/input-form-field.component';
import {SelectFormFieldComponent} from '@aviary/forms/fields/select-form-field/select-form-field.component';
import {buildFormGroup} from '@aviary/forms/form.helpers';
import {STATE_SELECT} from '@aviary/store/common/common.types';
import {SelectPipe} from '@aviary/pipes/select.pipe';
import {BranchSelectors} from '@store/branches/branch.selectors';
import {RegistrationActions} from '@store/registration/registration.actions';
import {FALLBACK_DETAILS_VALUE} from '@store/registration/registration.fallback';
import {RegistrationValidators} from '@store/registration/registration.validators';
import {MatCard, MatCardContent} from '@angular/material/card';
import {NgOptimizedImage} from '@angular/common';
import {FilledButtonComponent} from '@aviary/buttons/filled-button/filled-button.component';
import {ViewportSelectors} from '@aviary/store/viewport/viewport.selectors';

@Component({
  selector: 'px-registration-details-form',
  host: {
    class: 'flex flex-row gap-4 items-center justify-center md:justify-between lg:pl-10 lg:pr-20'
  },
  templateUrl: './registration-details-form.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [DateFormFieldComponent, InputFormFieldComponent, SelectFormFieldComponent, SelectPipe, MatCard, MatCardContent, NgOptimizedImage, FilledButtonComponent]
})
export class RegistrationDetailsFormComponent {
  private readonly store = inject(Store);
  public readonly STATE_SELECT = STATE_SELECT;
  public readonly branchSelectors = BranchSelectors.PickupLocations;
  public readonly viewportSelectors = ViewportSelectors;
  public readonly detailsForm: ExtendedFormGroup = buildFormGroup(FALLBACK_DETAILS_VALUE, inject(RegistrationValidators).enterDetails);

  public onClickNext() {
    this.store.dispatch(RegistrationActions.updateRegistration(this.detailsForm.value));
    this.store.dispatch(RegistrationActions.completeRegistrationStep('enterDetails'));
  }
}
